import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Onboarding } from '@templates';
import { Typography } from '@mixins';
import { theme } from '@styles';
import { routes } from '@constants';
import { ONBOARDING_STEPS } from '@constants/common';
import { updateCompanyOnboarding, getOnboardingFileLimits } from '@store/company/duck';

import CustomizeOnboarding from '@assets/images/CustomizeOnboarding.png';
import { TextArea } from '@atoms';

const CustomizeSpaceOnboarding = ({ direction }) => {
  const { onboardingState, onboardingFileLimits } = useSelector(store => store.companyStore);

  const [text, setText] = useState(onboardingState?.customRequests ?? '');

  useEffect(() => {
    if (!Object.keys(onboardingFileLimits).length) {
      dispatch(getOnboardingFileLimits());
    }
  }, []);

  useEffect(() => {
    if (onboardingState?.customRequests) {
      setText(onboardingState.customRequests);
    }
  }, [onboardingState?.customRequests]);

  const dispatch = useDispatch();
  const history = useHistory();

  const handleTextChange = event => {
    setText(event.target.value);
  };

  const handleUpdateText = () => {
    dispatch(
      updateCompanyOnboarding({
        currentStep: ONBOARDING_STEPS.CUSTOM_REQUESTS,
        customRequests: text,
      }),
    );
  };

  const handleBack = () => {
    handleUpdateText();

    history.push(routes.companyLogoOnboarding, { direction: 'back' });
  };

  const handleNavigateNext = () => {
    history.push(routes.arrivalDateOnboarding, { direction: 'forward' });
  };

  const handleNext = () => {
    dispatch(
      updateCompanyOnboarding({
        currentStep: ONBOARDING_STEPS.CUSTOM_REQUESTS,
        nextStep: ONBOARDING_STEPS.CONFIRM_ARRIVAL_DATE,
        customRequests: text,
      }),
    );

    handleNavigateNext();
  };

  return (
    <Onboarding
      onSaveAndContinueLater={handleUpdateText}
      onNext={handleNext}
      direction={direction}
      title="Customize Your Space"
      image={CustomizeOnboarding}
      showNavigationItems
      currentStep={3}
      onBack={handleBack}>
      <Typography
        variant="diatype-300"
        mb={30}
        fontSize={[14, 16, 20]}
        color={theme.color.mintMinded[900]}
        lineHeight="1.6">
        Any special requests for your new office?
      </Typography>
      <TextArea
        withBorder
        height="260px"
        width="100%"
        maxWidth="600px"
        fontSize={[10, 12, 14]}
        value={text}
        onChange={handleTextChange}
        placeholder="Tell us what you need (e.g., IT setup, furniture changes, installations)."
      />
      {onboardingFileLimits?.hasCustomRequestsAdditionalFee && (
        <Typography mt="10px" fontSize={[10, 12, 14]} color={theme.color.gray[500]}>
          Please note that certain changes may involve an additional fee.
        </Typography>
      )}
    </Onboarding>
  );
};

CustomizeSpaceOnboarding.defaultProps = {
  direction: null,
};

CustomizeSpaceOnboarding.propTypes = {
  direction: string,
};

export default CustomizeSpaceOnboarding;
